export default "__VITE_ASSET__CDxqrUou__"